import { Col, Form, FormInstance, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useCallback, useMemo } from "react";
import { CustomerInputSearch } from "../../../../../../../../components/CustomerInputSearch";
import { LeftFormCol } from "./LeftFormCol";
import { RightFormCol } from "./RightFormCol/Index";
import { PaymentFormItems } from "./RightFormCol/PaymentFormItems";

type GeneralInfoProps = {
  form: FormInstance;
  data: any;
  isDisabled: boolean;
};

export const GeneralInfo = ({ form, data, isDisabled }: GeneralInfoProps) => {
  const onSuccess = useCallback(
    (value: any) => {
      form.setFieldValue("bankAccountNumber", value?.bankAccountNumber);
    },
    [form]
  );

  const contractNames = useMemo(
    () => [
      {
        name: "primaryBuyerNumber",
        label: "Primary Buyer",
        idName: "primaryBuyerId",
        onSuccess,
      },
      {
        name: "primarySellerNumber",
        label: "Primary Seller",
        idName: "primarySellerId",
      },
    ],
    [onSuccess]
  );

  const notesRule = useMemo(() => {
    return [
      {
        max: 500,
      },
    ];
  }, []);

  const isBeginningPrincipalDisabled: boolean = useMemo(
    () => (data ? data.hasHistory : false) || isDisabled,
    [data, isDisabled]
  );

  return (
    <>
      <h5 className="h h5 card-header">General</h5>
      <Row className="mt-6">
        {contractNames.map((item: any, i: number) => (
          <Col
            className={`edit-account-contract-input ${
              i === 0 ? "pr-7" : "pl-7"
            }`}
            key={i}
          >
            <CustomerInputSearch
              form={form}
              label={item.label}
              name={item.name}
              isFormDisabled={isDisabled}
              idItemName={item.idName}
              onSuccess={item.onSuccess}
            />
          </Col>
        ))}
      </Row>
      <Row className="mt-6">
        <div className="w-100 divider" />
      </Row>
      <Row className="my-10">
        <LeftFormCol
          form={form}
          isBeginningPrincipalDisabled={isBeginningPrincipalDisabled}
        />
        <RightFormCol form={form} />
      </Row>
      <Row className="mb-10">
        <div className="w-100 divider" />
      </Row>
      <PaymentFormItems form={form} />
      <Row className="mb-10 mt-10">
        <div className="w-100 divider" />
      </Row>
      <Row>
        <Form.Item
          label="Notes"
          name={"notes"}
          className="notes"
          rules={notesRule}
        >
          <TextArea />
        </Form.Item>
      </Row>
    </>
  );
};
